// formatMoney renders a minor-unit integer (öre/cents) as a localized currency
// string. Money is integer minor units end-to-end in the backend; divide by 100
// only at the display boundary. Falls back gracefully when the currency is
// unset (pre-lock) or the runtime rejects the currency code.
export function formatMoney(minor: number, currency: string, locale: string): string {
  const major = minor / 100;
  if (!currency) return major.toFixed(2);
  try {
    return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency }).format(major);
  } catch {
    return `${major.toFixed(2)} ${currency}`;
  }
}

// formatMoneyRounded is the same but drops the decimals — used on compact KPI
// tiles where "84 200 kr" reads cleaner than "84 200,00 kr".
export function formatMoneyRounded(minor: number, currency: string, locale: string): string {
  const major = Math.round(minor / 100);
  if (!currency) return String(major);
  try {
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(major);
  } catch {
    return `${major} ${currency}`;
  }
}
